// extracted by mini-css-extract-plugin
export var about = "style-module--about--564fa";
export var container = "style-module--container--9c4fc";
export var left = "style-module--left--87d2c";
export var right = "style-module--right--df20f";